/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha4 = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M103 52V31.783c0-7.198-11.826-30.41-38.5-30.41-26.934 0-38.5 23.212-38.5 30.41v81.324C26 120.303 31.849 127 39.046 127h51.609c7.198 0 12.345-6.697 12.345-13.894V106h-7v-5h7V90h-7v-4h7V73h-7v-4h7V57h-7v-5h7zM64.852 74.53c-7.774 0-14.076-6.302-14.076-14.076s6.301-14.076 14.076-14.076c7.771 0 14.074 6.301 14.074 14.076S72.623 74.53 64.852 74.53zM88 18.619c0 1.513-1.525 2.737-3.037 2.737 0 0-10.187-5.734-19.831-5.734-10.165 0-19.537 5.734-19.537 5.734-1.511 0-2.595-1.225-2.595-2.737v-.26c0-1.511 1.167-2.061 2.52-2.737 1.129-.564 9.535-5.387 19.57-5.387 9.775 0 18.407 4.692 19.927 5.387C86.392 16.25 88 16.848 88 18.359v.26z" />
  </svg>
);
export default extendIcon(Deha4);
